import { memo } from "react";
import { FleetVehicle } from "services/api/fleet/vehicles/types";
import {
  ECO_CATEGORY_OPTIONS,
  OWNER_COUNT_OPTIONS,
  REGISTERED_UNTIL_OPTIONS,
} from "services/api/sales/listings/consts";
import { MarketplaceDetails } from "services/api/sales/listings/types";
import { ChipToggle } from "ui/modules/sales/pages/listings/components/ListingEditCard/components/MarketplaceStep/primitives";
import { InfoCard, InfoGrid, Section } from "./primitives";

interface Props {
  vehicle?: FleetVehicle | null;
  details?: MarketplaceDetails | null;
}

const labelFor = (opts: { value: string; text: string }[], code: string | null | undefined) => {
  if (!code) return null;
  return opts.find((o) => o.value === code)?.text ?? code;
};

// Sekcija "Ostali podaci o vozilu" — isti redoslijed polja i isti čipovi kao
// AdditionalDataSection na unosu.
const ListingAdditionalData: React.FC<Props> = ({ vehicle, details }) => {
  const v = vehicle ?? null;
  const d = details ?? null;

  return (
    <Section title="Ostali podaci o vozilu">
      <InfoGrid columns={3}>
        <InfoCard label="Potrošnja goriva (l/100km)" value={d?.fuelConsumption ?? "-"} />
        <InfoCard label="Prosječna emisija CO₂ (g/km)" value={d?.co2Emission ?? "-"} />
        <InfoCard label="Ekološka kategorija" value={labelFor(ECO_CATEGORY_OPTIONS, d?.ecoCategoryCode) ?? "-"} />

        <InfoCard label="Vozilo u prometu od (godina)" value={d?.inTrafficSinceYear ?? "-"} />
        <InfoCard label="Godina 1. registracije u RH" value={d?.firstRegistrationYearRH ?? "-"} />
        <InfoCard label="Registrirano do" value={labelFor(REGISTERED_UNTIL_OPTIONS, d?.registeredUntil) ?? "-"} />

        <InfoCard label="Vlasnik" value={labelFor(OWNER_COUNT_OPTIONS, d?.ownerCountCode) ?? "-"} />
        <InfoCard label="Broj šasije (VIN)" value={d?.chassisNumber ?? v?.vinNumber ?? "-"} />
        <InfoCard label="Interna šifra / registracija" value={d?.internalCode ?? "-"} />
      </InfoGrid>

      <div className="mt-4 mb-3 flex flex-wrap gap-2">
        <ChipToggle label="Plin (LPG/CNG)" selected={!!d?.hasGas} readOnly />
        <ChipToggle label="Garažiran" selected={!!d?.garaged} readOnly />
        <ChipToggle label="Servisna knjiga" selected={!!d?.serviceBook} readOnly />
      </div>
    </Section>
  );
};

export default memo(ListingAdditionalData);
